export default __webpack_public_path__ + "static/media/opp-24dp.50528565.svg";